exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "html[dir] ._2E--KoJqbPsPTFNbEdXz2y .ms-Dialog-action,html[dir] ._2E--KoJqbPsPTFNbEdXz2y .ms-Dialog-actionsRight{margin:initial}._2E--KoJqbPsPTFNbEdXz2y ._2yuVMd_4TXbou8DycF_FD1{width:100%}html[dir] ._2E--KoJqbPsPTFNbEdXz2y ._2yuVMd_4TXbou8DycF_FD1{margin:10px 0}", ""]);

// exports
exports.locals = {
	"dialog": "_2E--KoJqbPsPTFNbEdXz2y",
	"footerButton": "_2yuVMd_4TXbou8DycF_FD1"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":{"orderedValues":false}}!./node_modules/postcss-loader/lib?{"plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./obj/options/owa-options-core/lib/components/OptionConfirmationDialog.scss
// module id = 1835
// module chunks = 2 39 105 108